import { useCallback, useState } from 'react';
import { SaveFormModal } from '../../components/user/Records/modals/SaveFormModal';

export interface useSaveFormModalProps {
  isOpen: boolean;
  onSubmit: () => Promise<void>;
  onClose: () => Promise<void> | void;
  onCancel: () => Promise<void> | void;
}

export function useSaveFormModal({ isOpen, onSubmit, onCancel, onClose }: useSaveFormModalProps) {
  const [saving, setSaving] = useState(false);

  const handleSubmit = useCallback(async () => {
    setSaving(true);

    try {
      await onSubmit();
    } finally {
      setSaving(false);
    }
  }, [onSubmit]);

  const modal = <SaveFormModal isSubmitting={saving} open={isOpen} onSubmit={handleSubmit} onClose={onClose} onCancel={onCancel} />;

  return {
    modal,
  };
}
